export default __webpack_public_path__ + "static/media/ahmad.d60265a6.jpg";